import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('portaliRedirects');
export const actions = helper.createActions('portaliRedirects', actionTypes);
